import React, { useCallback } from 'react';

import { FormField } from '@gogame/form';

import { CREATIVE_TYPE } from 'scenes/Gallery/GalleryPage/Creatives/constants';
import { loadCreativeTypes } from 'scenes/Gallery/GalleryPage/Creatives/sources/fields';

const CreativeTypeComponent = ({
  label = 'Creative type',
  name = CREATIVE_TYPE,
  depends = [],
  fileInfo,
  required,
  padding,
}) => {
  const handleNormalizeCreativeType = useCallback((value, options) => {
    if (options) {
      return options[0].id;
    }
    return value;
  }, []);

  const loadCreativeTypesWithFile = useCallback(
    ({ ...props }) =>
      loadCreativeTypes({
        file: fileInfo,
        ...props,
      }),
    [loadCreativeTypes, fileInfo]
  );

  return (
    <FormField.Select
      label={label}
      name={name}
      depends={depends}
      source={loadCreativeTypesWithFile}
      normalizeValue={handleNormalizeCreativeType}
      padding={padding}
      required={required}
    />
  );
};
export default CreativeTypeComponent;
